<app-view-title [isPrimaryColor]="true"></app-view-title>
<view-content [centered]="true">
    <app-information-screen [centered]="true" [secondaryColor]="true"
                            title="{{ 'Intellitrailer.Rental.StowLock.LockOpenTitle' | translate : 'The lock is open!' }}"
                            primaryContent="{{ 'Intellitrailer.Rental.StowLock.LockOpenInstructions' | translate : 'The padlock is now unlocked and you can now remove the cover from the tow ball hitch. Please bring both the padlock and the cover with you.' }}"
                            secondaryContent="{{ 'Intellitrailer.Rental.StowLock.CloseLockInstructions' | translate : 'Remember to close the lock when storing it.' }}">
    </app-information-screen>

</view-content>
<view-actions>
  <button mat-raised-button color="accent" (click)="next()">{{ 'Intellitrailer.Navigation.Next' | translate : 'Next' }}</button>
</view-actions>

